import {CustomersHttp} from "../../../http/customers";

export default {
    async setCustomers({commit}) {
        const customers = await CustomersHttp.getAllCustomers().then(customers => customers.data);
        commit('setCustomers', customers);
    },
    async searchForCustomers({commit}, q) {
        const customers = await CustomersHttp.findCustomers(q).then(customers => customers.data);
        commit('setCustomers', customers);
    },
    setActiveCustomer({commit}, customer) {
        commit('setActiveCustomer', customer);
    },
    setManageCustomerDialog({commit}, status) {
        commit('setManageCustomerDialog', status);
    },
    setManageDeleteCustomerDialog({commit}, status) {
        commit('setManageDeleteCustomerDialog', status);
    }
}
